import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout-en"
import SEO from "../components/seo-en"
import { Helmet } from "react-helmet"
import Share from "../components/share-en"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import Hreflang from "../components/hreflang"

export default ({ data }) => {
  const post = data.markdownRemark
  const posts = data.allMarkdownRemark

  return (
    <Layout pathFr={post.frontmatter.pathFr || "/"}>
      <Hreflang fr={post.frontmatter.pathFr} en={post.fields.slug} />
      <Helmet>
        <script type="application/ld+json">
          {`
      {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "${post.frontmatter.title}",
        "item": "https://www.docteurphilipperoure.com${post.fields.slug}"
      }]
        }
    `}
        </script>
        <meta
          property="og:image"
          content={`https://www.docteurphilipperoure.com${post.frontmatter.image.childImageSharp.fluid.src}`}
        />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="813" />
        <meta property="og:image:height" content="464" />
        <meta
          property="og:url"
          content={`https://www.docteurphilipperoure.com${post.fields.slug}`}
        />
        <meta property="og:title" content={post.frontmatter.metaTitle} />
        <meta
          property="og:description"
          content={post.frontmatter.metaDescription}
        />
        <meta property="og:locale" content="en_US" />
        <meta property="fb:app_id" content="1086796511711258" />
      </Helmet>
      <SEO
        title={post.frontmatter.metaTitle}
        description={post.frontmatter.metaDescription}
      />
      <WrapperTitle>
        <WrapperTitleText>
          <Breadcrumb>
            <Link to="/en/">Home</Link>
          </Breadcrumb>
          <H1>{post.frontmatter.title}</H1>
          <Intro>{post.frontmatter.intro}</Intro>
        </WrapperTitleText>

        <WrapperTitleImage>
          <Img
            fluid={post.frontmatter.image.childImageSharp.fluid}
            css={css`
              margin: 0 auto;
              @media (max-width: 678px) {
                border-radius: 0 0 7px 7px;
              }
            `}
            alt={post.frontmatter.imageAlt}
          />
        </WrapperTitleImage>
      </WrapperTitle>

      <Share slug={post.fields.slug} title={post.frontmatter.title} />

      <WrapperText>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />

        {post.frontmatter.queryTag !== "sport" && (
          <GridWrapper>
            {posts.edges.map(({ node }) => {
              const { title, excerpt, image } = node.frontmatter
              const { slug } = node.fields
              return (
                <GridItem key={node.fields.slug}>
                  <Link
                    to={slug}
                    css={css`
                      text-decoration: none;
                    `}
                  >
                    <Img fluid={image.childImageSharp.fluid} />
                    <H3>{title}</H3>
                    <Description>{excerpt}</Description>
                    <Suite>> Lire la suite</Suite>
                  </Link>
                </GridItem>
              )
            })}
          </GridWrapper>
        )}
      </WrapperText>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!, $queryTag: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      fields {
        slug
      }
      frontmatter {
        title
        metaTitle
        metaDescription
        queryTag
        intro
        pathFr
        image {
          childImageSharp {
            fluid(maxWidth: 813) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
      html
    }
    allMarkdownRemark(
      limit: 500
      sort: { fields: [frontmatter___title], order: ASC }
      filter: { frontmatter: { tags: { eq: $queryTag } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            excerpt
            image {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`

const WrapperTitle = styled.div`
  position: relative;
  @media (max-width: 1000px) {
    display: block;
  }
`

const WrapperTitleText = styled.div`
  position: absolute;
  z-index: 1;
  top: 50%;
  max-width: 50%;
  background-color: white;
  transform: translateY(-50%);
  padding: 1.5em 1em 1em 1.2em;
  border-radius: 2px;
  flex: 0 0 40%;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 1000px) {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    max-width: 100%;
    transform: translateY(0%);
    top: 0;
    padding: 1.15em 0.75em 0.75em 0.9em;
  }
`

const WrapperTitleImage = styled.div`
  margin-left: 40%;
  max-width: 60%;
  flex: 0 0 60%;
  z-index: 0;
  @media (max-width: 1000px) {
    margin-left: 0;
    width: 100%;
    max-width: 100%;
    transform: translateY(0%);
  }
`

const Breadcrumb = styled.div`
  color: #e6ae48;
  text-align: center;
  font-size: 0.9em;
  line-height: 1em;
  font-weight: 400;
  a {
    color: #919090;
    text-decoration: none;
  }
  @media (max-width: 678px) {
    font-size: 0.87em;
    margin-bottom: 10px;
  }
`

const H1 = styled.h1`
  color: rgba(44, 44, 44, 0.96);
  @media (max-width: 678px) {
    font-size: 2.1em;
    line-height: 1.1em;
  }
`

const Intro = styled.p`
  font-size: 1.15em;
  line-height: 158%;
  @media (max-width: 678px) {
    font-size: 1.15em;
    line-height: 155%;
  }
`

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 32% 32% 32%;
  grid-template-row: 1fr 1fr 1fr;
  grid-gap: 2%;
  margin-bottom: 60px;
  @media (max-width: 1024px) {
    display: grid;
    grid-template-columns: 48% 48%;
  }
  @media (max-width: 678px) {
    display: block;
  }
`

const GridItem = styled.div`
  margin: 0.5em 0 0.5em;
  padding-bottom: 0.3em;
  transition: all 0.2s;
  .gatsby-image-wrapper img {
    transition: all 0.7s !important;
    transform: scale(1) !important;
  }
  &:hover {
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.18);
    transition: all 0.2s;
    .gatsby-image-wrapper img {
      transition: all 0.7s !important;
      transform: scale(1.05) !important;
    }
  }
  @media (max-width: 678px) {
    &:hover {
      box-shadow: none;
      .gatsby-image-wrapper img {
        transform: scale(1) !important;
      }
    }
  }
`

const H3 = styled.h3`
  font-size: 1.35em;
  line-height: 1.25em;
  letter-spacing: 0.03em;
  font-weight: 600;
  margin: 0;
  padding: 10px 14px 5px;
  @media (max-width: 678px) {
    font-size: 1.4em;
    min-height: auto;
    padding: 10px 3px 0;
  }
`
const Description = styled.div`
  padding: 0px 14px 8px;
  font-size: 0.93em;
  line-height: 1.55em;
  @media (max-width: 678px) {
    padding: 5px 3px 15px;
  }
`

const WrapperText = styled.div`
  background-color: white;
  border-radius: 5px;
  margin: 0.5em auto 1em;
  padding: 0.5em 1em 1em 1.2em;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 678px) {
    padding: 1em 0.7em 1em;
  }
`

const Suite = styled.p`
  display: none;
  font-size: 13px;
  opacity: 0.82;
  text-align: right;
  margin-right: 20px;
  font-weight: 400;
  margin-top: -8px;

  :hover {
    color: #d69c31;
  }
  @media (max-width: 1000px) {
    display: block;
  }
`
